type CoingeckoStats = {
  blockchains: number
  coins: number
  exchanges: number
}

export async function getCoingeckoStats() {
  const [coins, exchanges, blockchains] = await Promise.all([
    fetch(
      "https://raw.githubusercontent.com/privatefolio/coingecko/refs/heads/main/public/coins/count"
    )
      .then((res) => res.text())
      .then(Number),
    fetch(
      "https://raw.githubusercontent.com/privatefolio/coingecko/refs/heads/main/public/exchanges/count"
    )
      .then((res) => res.text())
      .then(Number),
    fetch(
      "https://raw.githubusercontent.com/privatefolio/coingecko/refs/heads/main/public/asset-platforms/count"
    )
      .then((res) => res.text())
      .then(Number),
  ])
  return {
    blockchains,
    coins,
    exchanges,
  } as CoingeckoStats
}
